module.exports = __webpack_public_path__ + "static/media/brand-car-wreck-beenleigh.8f747268.png";